import { Autocomplete, TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ComboboxProps } from './Combobox.types';
import React from 'react';
import { ErrorText } from '../Dropdown/Dropdown.styles';

export const Combobox = <T, >({
                                testId,
                                options,
                                value = null,
                                setSelectedOption,
                                label = 'Select',
                                isOptionEqualToValue,
                                renderOption,
                                width = '300px',
                                errorText,
                                ...props
                              }: ComboboxProps<T>): JSX.Element => {
  const muiTheme = createTheme();

  return (
    <>
      <ThemeProvider theme={muiTheme}>
        <Autocomplete
          data-testid={testId}
          disablePortal={false}
          value={value}
          options={options}
          size={'small'}
          sx={{
            width: width,
            background: '#fff',
            borderRadius: '0.5rem',
            border: '1px solid',
            borderColor: !!errorText ? '#d32f2f' : '#717170',
            '& .MuiFormControl-root': {
              borderRadius: '0.5rem',
            },
            '& .MuiSvgIcon-root': {
              color: !!errorText ? '#d32f2f' : 'rgba(0, 0, 0, 0.54)'
            },
          }}
          onChange={setSelectedOption}
          isOptionEqualToValue={isOptionEqualToValue}
          renderInput={(params) =>
            <TextField {...params} label={label} variant={'filled'} error={!!errorText}
                       sx={{
                         backgroundColor: '#fff',
                         '& .MuiFilledInput-root': {
                           background: '#fff',
                           borderRadius: '0.5rem',
                         },
                       }}
                       InputProps={{
                         ...params.InputProps,
                         disableUnderline: true,
                       }}
            />}
          renderOption={renderOption}
        />
      </ThemeProvider>
      {errorText ? <ErrorText aria-live="assertive">{errorText}</ErrorText> : <></>}
    </>
  );
};

export default Combobox;
